import { Factory } from 'rosie';

Factory.define('GreetingSuggestion');

Factory.define('GreetingSuggestionWithDefaults')
  .extend('GreetingSuggestion')
  .attr('id', 'default-id')
  .attr('text', 'Hi, how may I help you?')
  .attr('score', 10);
